import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LICENSE_PLANS } from '../services/webLicenseService';

// Información de pago por transferencia bancaria
const BANK_INFO = {
    clabe: '722969010029200517',
    beneficiary: 'ASCENSOS APP VORTEX (Fernando Avila)',
    whatsapp: 'https://wa.me/2296847814'
};

const WebLicensePurchase = () => {
    const navigate = useNavigate();
    const plans = Object.values(LICENSE_PLANS);
    const [copiedClabe, setCopiedClabe] = useState(false);

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopiedClabe(true);
            setTimeout(() => setCopiedClabe(false), 2000);
        });
    };

    const getPlanIcon = (planId) => {
        switch (planId) {
            case 'monthly': return '📅';
            case 'biannual': return '🗓️';
            case 'semiannual': return '📆';
            case 'annual': return '💎';
            default: return '⭐';
        }
    };

    const getPlanBadge = (planId) => {
        switch (planId) {
            case 'monthly': return { text: 'Básico', color: '#6b7280' };
            case 'biannual': return { text: 'Popular', color: '#3b82f6' };
            case 'semiannual': return { text: 'Conveniente', color: '#8b5cf6' };
            case 'annual': return { text: 'Premium', color: '#f59e0b' };
            default: return { text: '', color: '#6b7280' };
        }
    };

    return (
        <div style={{ marginTop: '2rem' }}>
            <h3 style={{
                margin: '0 0 1.5rem 0',
                fontSize: '1.5rem',
                color: '#fff'
            }}>
                Adquiere tu Licencia Web
            </h3>
            <p style={{
                color: '#94a3b8',
                marginBottom: '2rem',
                fontSize: '0.95rem'
            }}>
                Elige el plan que mejor se adapte a tus necesidades y accede inmediatamente a todas las funciones premium de la versión web.
            </p>

            <div style={{
                display: 'flex',
                gap: '1.5rem',
                marginBottom: '2rem',
                overflowX: 'auto',
                WebkitOverflowScrolling: 'touch',
                scrollSnapType: 'x mandatory',
                paddingBottom: '0.5rem',
                scrollbarWidth: 'thin',
                scrollbarColor: 'rgba(255,255,255,0.2) transparent'
            }}>
                {plans.map((plan) => {
                    const badge = getPlanBadge(plan.id);
                    const isRecommended = plan.id === 'biannual';

                    return (
                        <div key={plan.id} style={{
                            flex: '0 0 auto',
                            width: '260px',
                            scrollSnapAlign: 'start',
                            background: isRecommended
                                ? 'rgba(59, 130, 246, 0.15)'
                                : 'rgba(255, 255, 255, 0.05)',
                            border: isRecommended
                                ? '2px solid #3b82f6'
                                : '1px solid rgba(255, 255, 255, 0.1)',
                            borderRadius: '16px',
                            padding: '1.5rem',
                            textAlign: 'center',
                            position: 'relative',
                            transition: 'transform 0.3s, box-shadow 0.3s',
                            cursor: 'default'
                        }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.3)';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                        >
                            {isRecommended && (
                                <div style={{
                                    position: 'absolute',
                                    top: '-12px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    background: '#3b82f6',
                                    color: 'white',
                                    padding: '4px 16px',
                                    borderRadius: '20px',
                                    fontSize: '0.75rem',
                                    fontWeight: '600'
                                }}>
                                    ⭐ Recomendado
                                </div>
                            )}

                            <div style={{
                                fontSize: '3rem',
                                marginBottom: '0.5rem'
                            }}>
                                {getPlanIcon(plan.id)}
                            </div>

                            <h4 style={{
                                margin: '0 0 0.5rem 0',
                                color: '#fff',
                                fontSize: '1.25rem',
                                fontWeight: '600'
                            }}>
                                {plan.name}
                            </h4>

                            <div style={{
                                display: 'flex',
                                alignItems: 'baseline',
                                justifyContent: 'center',
                                gap: '0.25rem',
                                marginBottom: '0.5rem'
                            }}>
                                <span style={{
                                    fontSize: '2rem',
                                    fontWeight: '700',
                                    color: '#fff'
                                }}>
                                    ${plan.price}
                                </span>
                                <span style={{
                                    color: '#94a3b8',
                                    fontSize: '0.9rem'
                                }}>
                                    MXN
                                </span>
                            </div>

                            <p style={{
                                color: '#64748b',
                                fontSize: '0.8rem',
                                margin: '0 0 1rem 0'
                            }}>
                                {plan.description}
                            </p>

                            <button
                                onClick={() => navigate(`/stripe-checkout?plan=${plan.id}`)}
                                style={{
                                    width: '100%',
                                    background: 'linear-gradient(135deg, #635bff 0%, #4338ca 100%)',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '10px 16px',
                                    color: 'white',
                                    fontWeight: '600',
                                    fontSize: '0.9rem',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s',
                                    boxShadow: '0 4px 12px rgba(99, 91, 255, 0.3)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '0.5rem',
                                    marginTop: '0.5rem'
                                }}
                                onMouseOver={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 6px 16px rgba(99, 91, 255, 0.5)';
                                }}
                                onMouseOut={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(99, 91, 255, 0.3)';
                                }}
                            >
                                ⚡ Pagar con Stripe
                            </button>
                        </div>
                    );
                })}
            </div>

            {/* Pago Seguro */}
            <div style={{
                background: 'rgba(255, 255, 255, 0.03)',
                borderRadius: '12px',
                padding: '1.5rem',
                marginTop: '1.5rem'
            }}>
                <h5 style={{
                    margin: '0 0 1rem 0',
                    color: '#fff',
                    fontSize: '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                }}>
                    🔒 <span>Pago 100% Seguro</span>
                </h5>
                <ul style={{
                    margin: 0,
                    padding: 0,
                    listStyle: 'none',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '0.75rem'
                }}>
                    {[
                        '✅ Pago seguro procesado por Stripe',
                        '✅ Activación instantánea de licencia',
                        '✅ Acceso completo a versión web',
                        '✅ Soporte técnico por WhatsApp'
                    ].map((item, index) => (
                        <li key={index} style={{
                            color: '#94a3b8',
                            fontSize: '0.85rem',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem'
                        }}>
                            <span style={{ color: '#10b981' }}>✓</span>
                            {item.replace('✅ ', '')}
                        </li>
                    ))}
                </ul>
            </div>

            <p style={{
                color: '#64748b',
                fontSize: '0.8rem',
                textAlign: 'center',
                marginTop: '1.5rem',
                fontStyle: 'italic'
            }}>
                * Esta licencia es exclusiva para la versión web de Vortex EXANI-II y no incluye acceso a la aplicación móvil.
            </p>
        </div>
    );
};

export default WebLicensePurchase;
